import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { axiosRegisterInstance } from '../../../../axios.js';

import {
  INSERT_REGISTER_USER,
  INSERT_ROLE_SETTINGS,
  REGISTRATION_OTP_PHONE_SEND,
  REGISTRATION_OTP_EMAIL_SEND,
  VALIDATE_REGISTRATION_OTP,
  GET_SF_USER_DETAILS,
  CREATE_USER_ACCOUNT,
  RESET_PASSWORD,
  FORGOT_PASSWORD_OTP_EMAIL_SEND,
  RESET_FORGOT_PASSWORD,
  CREATE_ADMIN_USER_ACCOUNT,
  GET_SF_BUILDER_DETAILS
} from '../../../../Urls.js';

const initialState = {
  insertRegisterUserData: { data: [], loader: false },
  triggerPhoneOtpData: { data: {}, loader: false },
  phoneOtpVerfication: { data: {}, loader: false },
  triggerEmailOtpData: { data: {}, loader: false },
  emailOtpVerfication: { data: {}, loader: false },
  resetPassordData: { data: {}, loader: false },
  getSalesForceData: { data: {}, loader: false },
  sfBuilderData: { data: {}, loader: false },
};

export const insertRegisterUser = createAsyncThunk('app/inert/registerUserData', async reqData => {
  const response = await axios.put(INSERT_REGISTER_USER, { ...reqData });
  return response;
});

export const validateRegOtp = createAsyncThunk('app/inert/validateRegOtp', async reqData => {
  const response = await axiosRegisterInstance.post(VALIDATE_REGISTRATION_OTP, {
    ...reqData
  });
  return response;
});

export const getSalesForceUserDetails = createAsyncThunk(
  'app/registration/getSalesForceUserDetails',
  async emailOrPhone => {
    // delete axios.defaults.headers.common.Authorization;
    const response = await axiosRegisterInstance.get(GET_SF_USER_DETAILS + emailOrPhone);
    return response;
  }
);

export const getSalesForceBuilderDetails = createAsyncThunk(
  'app/registration/getSalesForceBuilderDetails',
  async ({ email, phone }) => {
    const response = await axiosRegisterInstance.get(GET_SF_BUILDER_DETAILS + "email=" + email + "&phone=" + phone);
    return response;
  }
);

export const saveUserDetails = createAsyncThunk(
  'app/registration/saveUserDetails',
  async payload => {
    const response = await axiosRegisterInstance.post(CREATE_USER_ACCOUNT, {
      ...payload
    });
    return response;
  }
);

export const generateRegistrationOTPforPhone = createAsyncThunk(
  'app/inert/registrationOTPPhone',
  async reqData => {
    // delete axios.defaults.headers.common.Authorization;
    const response = await axiosRegisterInstance.post(
      REGISTRATION_OTP_PHONE_SEND + `?phoneNumber=${reqData.phoneNumber}`
    );
    return response;
  }
);
export const generateRegistrationOTPforEmail = createAsyncThunk(
  'app/inert/registrationOTPEmail',
  async reqData => {
    // delete axios.defaults.headers.common.Authorization;
    const response = await axiosRegisterInstance.post(
      REGISTRATION_OTP_EMAIL_SEND + `?emailId=${reqData.emailId}`
    );
    return response;
  }
);
export const generateForgotpasswordOTPforEmail = createAsyncThunk(
  'app/inert/generateForgotpasswordOTPforEmail',
  async reqData => {
    const response = await axiosRegisterInstance.get(
      FORGOT_PASSWORD_OTP_EMAIL_SEND + `?emailId=${reqData.emailId}`
    );
    return response;
  }
);
export const resetPassword = createAsyncThunk('app/customer/resetPassword', async payload => {
  const response = await axios.post(RESET_PASSWORD, { ...payload });
  return response;
});
export const createAdminUser = createAsyncThunk('app/customer/resetPassword', async payload => {
  const response = await axios.post(CREATE_ADMIN_USER_ACCOUNT, { ...payload });
  return response;
});
export const resetForgotPassword = createAsyncThunk(
  'app/customer/resetForgotPassword',
  async payload => {
    const response = await axios.post(RESET_FORGOT_PASSWORD, { ...payload });
    return response;
  }
);

export const registerUserDetailSlice = createSlice({
  name: 'app/registerUserDetailSlice',
  initialState,
  reducers: {
    setinsertRegisterUserData: (state, action) => {
      state.insertRegisterUserData = action?.payload;
    }
  },
  extraReducers: builder => {
    builder

      // sf builder details
      .addCase(getSalesForceBuilderDetails.pending, state => {
        state.sfBuilderData.loader = true;
      })
      .addCase(getSalesForceBuilderDetails.fulfilled, (state, action) => {
        state.sfBuilderData.loader = false;
        state.sfBuilderData.data = action?.payload?.data?.data;
      })
      .addCase(getSalesForceBuilderDetails.rejected, state => {
        state.sfBuilderData.loader = false;
      })


      .addCase(insertRegisterUser.pending, state => {
        state.insertRegisterUserData.loader = true;
      })
      .addCase(insertRegisterUser.fulfilled, (state, action) => {
        state.insertRegisterUserData.loader = false;
        state.insertRegisterUserData.data = action?.payload?.data?.data;
      })
      .addCase(insertRegisterUser.rejected, state => {
        state.insertRegisterUserData.loader = false;
      })

      .addCase(getSalesForceUserDetails.pending, state => {
        state.getSalesForceData.loader = true;
      })
      .addCase(getSalesForceUserDetails.fulfilled, (state, action) => {
        state.getSalesForceData.loader = false;
        state.getSalesForceData.data = action?.payload?.data?.data;
      })
      .addCase(getSalesForceUserDetails.rejected, state => {
        state.getSalesForceData.loader = false;
      })

      .addCase(generateRegistrationOTPforPhone.pending, state => {
        state.triggerPhoneOtpData.loader = true;
      })

      .addCase(generateRegistrationOTPforPhone.fulfilled, (state, action) => {
        state.triggerPhoneOtpData.loader = false;
        state.triggerPhoneOtpData.data = action?.payload?.data?.data;
      })
      .addCase(generateRegistrationOTPforPhone.rejected, state => {
        state.triggerPhoneOtpData.loader = false;
      })

      .addCase(generateRegistrationOTPforEmail.pending, state => {
        state.triggerEmailOtpData.loader = true;
      })

      .addCase(generateRegistrationOTPforEmail.fulfilled, (state, action) => {
        state.triggerEmailOtpData.loader = false;
        state.triggerEmailOtpData.data = action?.payload?.data?.data;
      })
      .addCase(generateRegistrationOTPforEmail.rejected, state => {
        state.triggerEmailOtpData.loader = false;
      })
      .addCase(resetPassword.pending, state => {
        state.resetPassordData.loader = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPassordData.loader = false;
        state.resetPassordData.data = action?.payload?.data?.data;
      })
      .addCase(resetPassword.rejected, state => {
        state.resetPassordData.loader = false;
      });
  }
});

export const { setSelectedAccount, addServiceTickets, setViewServiceTicket } =
  registerUserDetailSlice.actions;

export default registerUserDetailSlice.reducer;
